// libs
import React, { memo } from 'react';
import { useLocation } from 'react-router';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// constants
import { IOS_APP_ID } from 'shared/constants';
import { Helmet } from 'react-helmet-async';
const ARGUMENT_REFERENCE = 'smart_app_banner';

function SmartAppBanner() {
  const { pathname, search } = useLocation();
  const smartAppBannerConfig = useRemoteConfig('smartAppBanner') || {};
  const { enabledUrl = [], enabledForAll = false } = smartAppBannerConfig;

  if (enabledForAll || (Array.isArray(enabledUrl) && enabledUrl.includes(pathname))) {
    const searchParam = new URLSearchParams(search);
    searchParam.set('src', ARGUMENT_REFERENCE);

    const url = process.env.API_HOST + pathname + '?' + searchParam.toString();

    return (
      <Helmet>
        <meta name="apple-itunes-app" content={`app-id=${IOS_APP_ID}, app-argument=${url}`}></meta>
      </Helmet>
    );
  }
  return null;
}

export default memo(SmartAppBanner);
